"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _invoices = require("@module/invoices");

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _reduxForm = require("redux-form");

var _reactRedux = require("react-redux");

var _RefundForm = _interopRequireDefault(require("./RefundForm"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function CreateRefundDialog(_ref) {
  var data = _ref.data,
      onSubmit = _ref.onSubmit;

  try {
    var handleSubmitForm = function handleSubmitForm() {
      dispatch((0, _reduxForm.submit)('create-refund'));
    };

    var handleSubmit = function handleSubmit(formData) {
      onSubmit(formData);
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var isValidForm = (0, _reactRedux.useSelector)((0, _reduxForm.isValid)('create-refund'));
    var inRefundProcess = (0, _reactRedux.useSelector)(_invoices.selectInRefundProcess);
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: _defaultModule["default"]['wrapper'],
      "data-locator": "refund.dialog"
    }, /*#__PURE__*/_react["default"].createElement("article", {
      className: _defaultModule["default"]['content'],
      "data-locator": "refund.dialog.content"
    }, /*#__PURE__*/_react["default"].createElement(_RefundForm["default"], {
      initialValues: data,
      disabled: inRefundProcess,
      onSubmit: handleSubmit
    })), /*#__PURE__*/_react["default"].createElement("footer", {
      className: _defaultModule["default"]['controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": "refund.submit",
      type: "submit",
      mode: "success",
      inProcess: inRefundProcess,
      disabled: !isValidForm,
      onClick: handleSubmitForm
    }, "\u0412\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C")));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = CreateRefundDialog;
exports["default"] = _default;